import React from 'react'

export const OrderDetailsInfo = ({ order }) => {
  return (
    <div className="row mb-5 order-info-wrap">
      <div className="col-md-6 col-lg-4">
        <article className="icontext align-items-start">
          <span className="icon icon-sm rounded-circle alert-success">
            <i className="text-success fas fa-user"></i>
          </span>
          <div className="text">
            <h6 className="mb-1">Customer</h6>
            <p className="mb-1">
              {order?.user?.name} <br />
              <a href={`mailto:${order?.user?.email}`}>{order?.user?.email}</a>
            </p>
          </div>
        </article>
      </div>

      <div className="col-md-6 col-lg-4">
        <article className="icontext align-items-start">
          <span className="icon icon-sm rounded-circle alert-success">
            <i className="text-success fas fa-truck-moving"></i>
          </span>
          <div className="text">
            <h6 className="mb-1">Order Info</h6>
            <p className="mb-1">
              Shipping: {order?.shippingAddress?.country} <br />
              Payment Method: {order?.paymentMethod}
            </p>
          </div>
        </article>
      </div>

      <div className="col-md-6 col-lg-4">
        <article className="icontext align-items-start">
          <span className="icon icon-sm rounded-circle alert-success">
            <i className="text-success fas fa-truck-moving"></i>
          </span>
          <div className="text">
            <h6 className="mb-1">Delivery Address</h6>
            <p className="mb-1">
              Address: {order?.shippingAddress?.city} <br />
              {order?.shippingAddress?.postalCode}
            </p>
          </div>
        </article>
      </div>
    </div>
  );
}
